import React from 'react';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';

export const tabsTypes = {
    overview: {
        id: 'overview',
        text: 'Overview'
    },
    holeGuide: {
        id: 'holeGuide',
        text: 'Hole Guide'
    },
    highlights: {
        id: 'highlights',
        text: 'Highlights'
    }
};

export const liveHoleTabs = [
    {
        id: 'overview',
        text: 'Overview'
    },
    {
        id: 'holeGuide',
        text: 'Hole Guide'
    },
    {
        id: 'highlights',
        text: 'Highlights'
    }
];

export const getLiveHoleTabs = () => {
    return cloneDeep(liveHoleTabs);
};


export const HOLE_ID_QS_NAME = 'popupHoleId';

export const getHoleExternalLink = (url, id) => {
    return `${url}?${HOLE_ID_QS_NAME}=${id}`;
};

export const getHardestHole = (scoringRound, holeId) => {
    if (!scoringRound ||
        !scoringRound.hardestHoles ||
        !scoringRound.hardestHoles.stats ||
        !holeId
    ) {
        return null;
    }

    const statsHardestHolesList = scoringRound.hardestHoles.stats;
    const statsItemIndex = findIndex(statsHardestHolesList, (el) => el.holeId === Number(holeId));
    let title = '';

    if (statsItemIndex + 1 === 0) return null;

    let holePosition = 0;

    if (statsItemIndex <= 8) {
        title = 'Hardest Hole';
        holePosition = statsItemIndex + 1;
    } else {
        title = 'Easiest Hole';
        holePosition = 18 - (statsItemIndex);
    }

    let postfixes = '';

    switch (holePosition) {
        case 1:
            postfixes = 'st';
            break;
        case 2:
            postfixes = 'nd';
            break;
        case 3:
            postfixes = 'rd';
            break;
        default:
            postfixes = 'th';
    }

    return <span>{holePosition}<sup>{postfixes}</sup> {title}</span>;
};
